import { render, staticRenderFns } from "./CiVehiclePreview.vue?vue&type=template&id=31a88fb4&"
import script from "./CiVehiclePreview.vue?vue&type=script&lang=js&"
export * from "./CiVehiclePreview.vue?vue&type=script&lang=js&"
import style0 from "./CiVehiclePreview.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports